import type { KAPLAYCtxT } from 'kaplay'

export default function (k: KAPLAYCtxT) {
  k.loadSprite('player_male', 'sprites/characters/player_male.png', {
    sliceX: 6,
    sliceY: 5,
    anims: {
      face_up: {
        frames: [1],
      },
      face_down: {
        frames: [3],
      },
      face_left: {
        frames: [2],
      },
      face_right: {
        frames: [0],
      },
      run_up: {
        from: 12,
        to: 17,
        loop: true,
      },
      run_down: {
        from: 24,
        to: 29,
        loop: true,
      },
      run_left: {
        from: 18,
        to: 23,
        loop: true,
      },
      run_right: {
        from: 6,
        to: 11,
        loop: true,
      },
    },
  })

  k.loadSprite('uiFrame', 'sprites/ui-frame.png', {
    slice9: {
      top: 16,
      bottom: 16,
      left: 16,
      right: 16,
    },
  })

  k.loadSprite('ui', 'sprites/ui.png', {
    sliceX: 4,
    sliceY: 2,
    anims: {
      music_on: {
        frames: [0],
      },
      music_off: {
        frames: [1],
      },
      list: {
        frames: [2],
      },
      popupCloseBtn: {
        frames: [3],
      },
    },
  })
}
